import React from "react";
import {
  FilterDatePickerBase,
  FormDatePickerBase,
  FilterDatePickerProps,
  FormDatePickerProps,
} from "./DatePickerBase";

export const FormDatePicker = (props: FormDatePickerProps) =>
  <FormDatePickerBase
    {...props}
    mode="single"
  />

export const FilterDatePicker = (props: FilterDatePickerProps) =>
  <FilterDatePickerBase
    {...props}
    mode="single"
  />